export default __webpack_public_path__ + "static/media/triangulosJuntos.75b0f6af.png";